import { Navigate } from 'react-router-dom';

import { Spinner } from '@/components/generic';
import { useAuth } from '@/contexts';
import { PUBLIC_PAGE_ROUTES } from '@/enums';
import { getDefaultPrivateRoute } from '@/helpers';

export const RouterFallback = () => {
  const { user, currentUserData, isAuthLoading } = useAuth();

  if (isAuthLoading) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <Spinner />
      </div>
    );
  }

  if (user) {
    return <Navigate to={getDefaultPrivateRoute(currentUserData)} replace />;
  }

  return <Navigate to={PUBLIC_PAGE_ROUTES.LOGIN} replace />;
};
